import useMsalUser from '@shared/hooks/useMsalUser';
import { ReactNode, useEffect } from 'react';

import CircularLoading from '../Loaders/CircularLoading';

interface Props {
    children: ReactNode;
    loadingFallback?: ReactNode;
}

export default function SecureMsalRoute({ children, loadingFallback }: Props) {
    const { signIn, isAuthenticated, getUser, redirectToLogin } = useMsalUser();

    const loadingComponent = loadingFallback ? loadingFallback : <CircularLoading />;

    useEffect(() => {
        signIn();
    }, [signIn]);

    useEffect(() => {
        if (isAuthenticated && !getUser()) {
            redirectToLogin();
        }
    }, [isAuthenticated, getUser, redirectToLogin]);

    return (
        <>
            {isAuthenticated && children}
            {!isAuthenticated && loadingComponent}
        </>
    );
}
